import * as React from "react";
import {List, ListItem, ListItemIcon, ListItemText, Typography, Link, Grid, Container} from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {MediaQueryCheck, IsRtl, GetLocaleData} from "../customHook/useGlobal"

export default function FeatureInfo() {
    const staticData = {
        myaccountLbl: {
            en: "My Account",
            ar: "حسابي"
        },
        loginDashboard: {
            lbl: {
                en: "Login to your dashboard",
                ar: "الدخول إلى لوحة التحكم الخاصة بك",
            },
            link: {
                en: "https://myaccount.du.ae/servlet/du/en/home.html",
                ar: "https://myaccount.du.ae/servlet/du/ar_AE/home.html"
            }
        },
        features: [
            {
                en: "Track your account balances and billing history",
                ar: "تتبع حسابك من خلال الأرصدة وسجل الفواتير"
            },
            {
                en: "Optimize your voice and data use to save more",
                ar: "تحسين استخدام المكالمات الصوتية والبيانات لتوفير المزيد"
            },
            {
                en: "Set it and forget it, with autopay and reminders",
                ar: "قم بتعيينها ونسيانها ، بإستخدام ميزة التشغيل التلقائي والتذكيرات"
            }
        ]
    }

    const isScreenMedium = MediaQueryCheck("md")
    const isScreenExtraSmall = MediaQueryCheck("xs")

    const isRtl = IsRtl()

    return (
        <React.Fragment>
            <Container disableGutters>
                <Grid container alignItems="center" justifyContent={isScreenMedium ? "center" : undefined} maxWidth="md" sx={{ py: isScreenMedium ? 8 : 2, mx: "auto", px: isScreenExtraSmall && 5 }}>
                    <Grid item md={false} columnSpacing={2}>
                        <Typography variant="h4">{GetLocaleData(staticData.myaccountLbl)}</Typography>
                        <Link href={GetLocaleData(staticData.loginDashboard.link)}  color="primary" underline="none" sx={{ display: "flex" }}>
                            {GetLocaleData(staticData.loginDashboard.lbl)}
                            { isRtl ?
                                <ChevronLeftIcon fontSize="small" color="text.primary" /> : <ChevronRightIcon fontSize="small" color="text.primary" /> }
                        </Link>
                    </Grid>
                    <Grid item md={false} sx={{ ml: isScreenMedium && 2 }}>
                        <List dense>
                            { staticData.features.map((feature, i) =>
                                <ListItem key={i} sx={{ pl: isScreenExtraSmall && 0 }}>
                                    <ListItemIcon sx={{minWidth: 24}}>
                                        <CheckIcon fontSize="xsmall" color="text.primary"/>
                                    </ListItemIcon>
                                    <ListItemText primary={GetLocaleData(feature)} />
                                </ListItem>
                            )}
                        </List>
                    </Grid>
                </Grid>
            </Container>
        </React.Fragment>
    );
}